export default __webpack_public_path__ + "static/media/addon4.9578fb6f.webp";